import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaInfoCircle } from 'react-icons/fa';

const BillingCancelledPage = () => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white rounded-2xl p-8 max-w-md w-full shadow-xl text-center" data-testid="billing-cancelled-card">
        <FaInfoCircle className="text-4xl text-gray-400 mx-auto mb-4" />
        <h2 className="text-xl font-bold mb-2">Betaling afbrudt</h2>
        <p className="text-gray-600 mb-6 text-sm">
          Du har afbrudt Stripe-checkout. Der er ikke trukket noget på dit kort. Du kan altid prøve igen senere.
        </p>
        <button
          data-testid="billing-cancelled-back-btn"
          onClick={() => navigate('/')}
          className="w-full bg-gray-100 text-gray-800 font-medium py-3 rounded-lg hover:bg-gray-200"
        >
          Tilbage til forsiden
        </button>
      </div>
    </div>
  );
};

export default BillingCancelledPage;
